import React from "react"
import ReactMarkdown from "react-markdown"
import Button from "@components/objects/Button/Button"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import ProductArchiveCard from "../ProductArchiveCard/ProductArchiveCard"
import * as styles from "./ProductArchive.module.scss"

const ProductArchive = ({ edits }) => (
  <section className={styles.ProductArchive}>
    <SiteWrapper className={styles.intro}>
      <h1>The Shop</h1>
      <ReactMarkdown>Shop the Edits curated by the HOPP team.</ReactMarkdown>
      <Button
        text="Browse All"
        link="/product-search"
        // design=""
        color="pink"
        className={styles.button}
      />
    </SiteWrapper>
    <SiteWrapper className={styles.list}>
      {edits && edits.length
        ? edits.map((edit) => <ProductArchiveCard key={edit.id} edit={edit} />)
        : null}
    </SiteWrapper>
  </section>
)

export default ProductArchive
